import { inject } from '@vakantiesnl/services/src/util/template';
import { type Booking, type MicroCopy } from '@vakantiesnl/types/src';

export const getCarryOnDimensions = (carryOnLuggage: Booking.CarryOnLuggage, microCopy: MicroCopy): string =>
	inject(microCopy['common.handLuggageDimensions'], {
		width: carryOnLuggage.width.toString(),
		height: carryOnLuggage.height.toString(),
		depth: carryOnLuggage.depth.toString(),
	}).join('');
